export type ActivityState = 'idle' | 'filling' | 'draining' | 'busy';

export type LiveConsumeActivity = 'file' | 'encode' | 'segmentProxy' | 'provide';

export interface MovingStatistic {
  last: number;
  all: number;
}

export type ActivityAnalysis = Partial<Record<ActivityState, MovingStatistic>>;

export interface MediaThroughput {
  activities: Record<LiveConsumeActivity, ActivityAnalysis>;
}

export enum OperationConclusion {
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded'
}

export type ProgressInfo = {
  // Short user-visible state description text. Limit to one or two words. Not a machine readable identifier.
  // NEW indicates to the client to not show the progress info even though it is present.
  status: string | 'NEW';

  // Undefined or a number between 0 and 100.
  //
  // Interpretation:
  //  * undefined -- Activity not yet started, or activity has already concluded. UI should not show progress bar or spinner.
  //  * 0 -- Conclusion of activity is still pending, but no progression information is available. UI should show spinner.
  //  * >0 -- Conclusion of activity is still pending, and progress information is available. UI should show progess bar.
  percentage?: number;

  // User-visible tooltip text when hovering over progress display. May contain multiple lines.
  description?: string;

  // Detailed error messages, including technical information.
  // Also includes warnings. Does not imply complete failure.
  errors?: string[];

  // Machine readable identifier specifying context independent operation conclusion.
  conclusion?: OperationConclusion;

  throughput?: MediaThroughput;
};

/**
 * Represents a progress step.
 */
export enum ProgressStep {
  // kelda
  CONFORM_RESTORE_DEPENDENCIES = 'Restoring dependencies',
  SENT_TO_AME = 'Sent to AME',
  SENT_TO_DVR = 'Sent to DVR',
  CONFORM_RENDERED = 'Rendered',
  P2_REMUXING = 'Remuxing',
  P2_STITCHING = 'Stitching',
  CREATING_THUMBNAIL = 'Creating thumbnail',
  UPLOADING_THUMBNAIL = 'Uploading thumbnail',
  UPLOADED_THUMBNAIL = 'Thumbnail uploaded',
  ITEM_SEARCHABLE = 'Item searchable',
  CLAIMED_FOR_INGEST = 'Claimed for ingest',
  CREATING_PROXY = 'Transcoding',
  UPLOADING = 'Uploading',

  // kelda & mimir-common
  DOWNLOADING_DEPENDENCIES = 'Downloading dependencies',
  RENDERING = 'Rendering',
  RETRIEVING_EXTERNAL_HIGHRES = 'Retrieving external highres',

  RESTORE_OFFLINE_HIGHRES = 'Restoring offline highres',

  // mimir-common
  PREPARING_AUDIO = 'Preparing audio',
  CLIENT_UPLOAD_COMPLETE = 'Content uploaded',
}

